import { useId, type SVGProps } from "react";

const HEX = "M32 4L56.25 18L56.25 46L32 60L7.75 46L7.75 18Z";
const LIGHT = "M32 4L7.75 18L7.75 32Z";
const DARK = "M48.16 32L56.25 32L56.25 46Z";
const UP = "M32 4L56.25 46L7.75 46Z";
const DOWN = "M32 60L56.25 18L7.75 18Z";

/** Faceted hexagon mark: periwinkle body, light top facet, navy lower-right facet. */
export function LogoMark({ title = "Baze", ...props }: SVGProps<SVGSVGElement> & { title?: string }) {
  const clip = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 64 64" role="img" aria-label={title} {...props}>
      <defs>
        <clipPath id={clip}>
          <path d={HEX} />
        </clipPath>
      </defs>
      <path fill="#7985EB" d={HEX} />
      <path fill="#C8CCF9" d={LIGHT} />
      <path fill="#141B73" d={DARK} />
      <g fill="none" stroke="#fff" strokeWidth="1.6" strokeLinejoin="round" clipPath={`url(#${clip})`}>
        <path d={UP} />
        <path d={DOWN} />
        <path d="M7.75 32H56.25" />
      </g>
    </svg>
  );
}

export interface LogoProps {
  /** "mark" = icon only; "lockup" = icon + wordmark (+ optional tagline). */
  variant?: "mark" | "lockup";
  tagline?: string | false;
  className?: string;
  /** Use on dark backgrounds. */
  inverted?: boolean;
}

export function Logo({ variant = "lockup", tagline = false, className = "", inverted = false }: LogoProps) {
  const mark = <LogoMark className="size-8 shrink-0" aria-hidden="true" title="" />;
  if (variant === "mark") return <span className={className}>{mark}</span>;
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {mark}
      <span className="flex flex-col leading-tight">
        <span className={`text-sm font-bold ${inverted ? "text-white" : "text-slate-900"}`}>
          Baze<span className={inverted ? "text-brand-300" : "text-brand-600"}>Build</span>
        </span>
        {tagline ? <span className={`whitespace-nowrap text-[11px] ${inverted ? "text-slate-300" : "text-slate-400"}`}>{tagline}</span> : null}
      </span>
    </span>
  );
}
